<template>
  <div class="page">
    <!-- <p class="title">爪玩用户服务协议</p> -->
    <div class="paragraph">
      <div class="subTitle">1.声明与承诺</div>
      <div class="content">
        <p class="sub-paragraph">
          1.1
          本服务协议内容包括协议正文及所有爪玩已经发布的或将来可能发布的各类规则。所有规则为协议不可分割的组成部分，与本协议正文具有同等效力。
        </p>
        <p class="sub-paragraph">
          1.2
          用户同意所有协议条款并完成注册程序，才能成为爪玩的正式用户。用户在使用爪玩及爪玩提供的各项服务的同时，承诺接受并遵守各项相关规则的规定。
        </p>
        <p class="sub-paragraph">
          1.3
          爪玩有权根据需要不时地制定、修改本协议或各类规则，如本协议有任何变更，爪玩将在客户端或网站上刊载公告，用户需及时关注并注意遵守该等规则。
        </p>
        <p class="sub-paragraph">
          1.4
          用户登录或继续使用“服务”将表示用户接受经修订的协议或规则。除另行明确声明外，任何使“服务”范围扩大或功能增强的新内容均受本协议约束。
        </p>
        <p class="sub-paragraph">
          1.5
          用户申请注册即视为同意本协议，请用户务必审慎阅读、充分理解各条款内容，特别是免除或者限制责任的条款、法律适用和争议解决条款。免除或者限制责任的条款将以粗体下划线标识，用户应重点阅读。阅读本协议的过程中，如果用户不同意本协议或其中任何条款约定，用户应立即停止注册程序。请用户务必在注册之前认真阅读全部服务协议内容，如有任何疑问，可向爪玩客服咨询。无论用户事实上是否在注册之前认真阅读了本服务协议，只要用户选择同意本协议并按照爪玩注册程序成功注册为用户，用户的行为仍然表示其同意并签署了本服务协议。
        </p>
      </div>
    </div>
    <div class="paragraph">
      <div class="subTitle">2. 定义</div>
      <div class="content">
        <p class="sub-paragraph">
          2.1 “爪玩”：指偏爱信息下的个人闲置物品和二手物品交换交易平台。
        </p>
        <p class="sub-paragraph">
          2.2
          “用户”：用户应当是具有完全民事权利能力和完全民事行为能力的自然人、法人或其他组织，并能够根据相关法律订立具有法律约束力的合约并成为爪玩用户。无民事行为能力人、限制民事行为能力人以及无经营资格或特许经营资格的组织不当注册为爪玩用户或超越其民事权利或行为能力范围从事爪玩的，其与爪玩及爪玩之间的服务协议自始无效，爪玩一经发现，有权立即注销该用户。若您不具备前述与您行为相适应的民事行为能力，则您及您的监护人应依照法律规定承担因此而导致的一切后果。
        </p>
        <p class="sub-paragraph">
          2.3
          用户注册：是指用户进入爪玩，通过微信账号登陆或手机号登陆，按要求填写相关信息并确认同意履行相关用户协议的过程。
        </p>
        <p class="sub-paragraph">
          2.4“微信担保支付”：是指用户因交易发生支付时，先行通过微信支付方式将交易款项支付至爪玩微信支付账户，在付款方用户确认交易完毕时，付款方用户在线确认“已收货”或收款方用户确认该笔交易已取消或本协议约定的期限届满时，付款方自动委托爪玩微信支付账户将该支付款项支付至交易对方的微信支付账户或卖方自动委托爪玩微信支付账户将该支付款项退回至付款方微信支付账户的支付方式。如在线交易双方就支付事项无法达成一致意见期间，买卖双方共同同意该笔付款将暂时冻结在爪玩微信支付账户中，直至双方达成一致意见后，爪玩微信账户就该笔付款予以解冻并根据双方的共同意愿支付，并且买卖双方用户同意,
          爪玩微信账户代付后, 非经法律程序或者非依本协议之约定,
          该支付是不可撤销的，爪玩微信账户的支付行为视为经买卖双方的共同授权代为支付的行为。
        </p>
        <p class="sub-paragraph">
          2.5
          “逾期未付款”：是指买方选择线上交易，在线拍下乙方平台物品，使得该物品处于已下订单未支付状态，买方在下单后2个小时内未完成在线付款，视为逾期未付款。
        </p>
        <p class="sub-paragraph">
          2.6
          “发货”，是指通过爪玩交换平台在线交易的用户，用户发出货物并及时在线提交发货快递信息（包含但不限于快递方、快递单号等），在爪玩平台达成交易后，视为“已发货”。
        </p>
        <p class="sub-paragraph">
          2.7
          “收货”，是指通过爪玩交易平台的用户，进行闲置物品交易过程中，对交易物品的实际签收或收受的行为。
        </p>
      </div>
    </div>
    <div class="paragraph">
      <div class="subTitle">3.用户权利和义务</div>
      <div class="content">
        <p class="sub-paragraph">
          3.1
          请妥善保管好用户的用户名（会员名）、密码以及密保信息，用户须对用户在会员用户名（会员名）和密码进行的所有活动承担责任。
        </p>
        <p class="sub-paragraph">
          3.2
          用户同意：如发现任何人未经授权使用用户的会员注册名或密码，或发生会员注册名及密码泄露的任何其他情况，用户应当立即通知爪玩，要求暂停爪玩相关服务；请确保用户在每个上网时段结束时，以正确步骤离开网站。爪玩不对因用户未能遵守本网站规定而发生的任何损失或损毁负责。
        </p>
        <p class="sub-paragraph">
          3.3
          用户在爪玩上交易过程中如与其他用户因交易产生纠纷，可以请求爪玩从中予以协调。用户如发现其他用户有违法或违反本服务协议的行为，可以向爪玩进行反映要求处理。如用户因网上交易与其他用户产生诉讼的，用户有权通过司法部门要求爪玩提供相关资料。
        </p>
        <p class="sub-paragraph">
          3.4
          用户有义务在注册时提供自己的真实的身份资料（或企业登记资料）并实名注册，并保证诸如联系电话、联系地址、邮政编码等内容的有效性及安全性，同时，用户也有义务在相关资料实际变更时及时更新有关注册资料。用户保证不以他人资料在爪玩进行注册或认证；用户理解并同意，爪玩有权应政府部门（包括司法及行政部门）的要求，向其提供用户在爪玩填写的注册信息和交易记录等必要信息。如用户涉嫌侵犯他人知识产权，则爪玩亦有权在初步判断涉嫌侵权行为存在的情况下，向权利人提供用户必要的身份信息。
        </p>
        <p class="sub-paragraph">
          3.5
          用户应当保证在使用爪玩共享平台进行交易的过程中遵守诚实信用的原则，不在交易过程中采取不正当竞争行为，不扰乱网上交易的正常秩序，不从事与共享资源无关的行为；用户在使用爪玩服务过程中，所产生的应纳税费，以及一切硬件、软件、服务及其它方面的费用，均由用户独自承担。
        </p>
        <p class="sub-paragraph">
          3.6
          用户不得在爪玩共享平台上恶意评价其他用户，或采取不正当手段提高自身与事实不符的信用度或降低其他用户的信用度。
        </p>
        <p class="sub-paragraph">
          3.7 用户在爪玩的平台上不得发布各类违法或违规信息。
        </p>
        <p class="sub-paragraph">
          3.8
          用户在爪玩平台上发布或交换产品信息及产品价格信息应真实、合法、有效，用户对其发布或交换的产品有合法的处分权或者已获得合法处分权人的充分授权，交换方具有履行其在合同项下的各项义务的能力。用户将按照《中华人民共和国消费者权益保护法》、《中华人民共和国消费者权益保护法》等法律、法规和规范性文件和国家强制性标准的规定，对其爪玩上货品进行交易并提供售后服务。
          用户不得发布或交换国家禁止销售的或限制销售的物品、不得发布或交换侵犯他人知识产权或其它合法权益的物品，也不得发布或交换违背社会公共利益或公共道德的、或是爪玩认为不适合在爪玩上进行交易的物品。
        </p>
        <p class="sub-paragraph">
          3.9
          用户承诺自己在使用爪玩时实施的所有行为均遵守国家法律、法规和爪玩的相关规定以及各种社会公共利益或公共道德。如有违反导致任何法律后果的发生，用户将以自己的名义独立承担所有相应的法律责任。
        </p>
        <p class="sub-paragraph">
          3.10
          用户同意，不对爪玩上任何数据作商业性利用，包括但不限于在未经爪玩事先书面批准的情况下，以复制、传播等方式使用在爪玩站上展示的任何资料；用户同意接收来自爪玩发出的邮件、信息。
        </p>
        <div class="sub-paragraph">
          <p>3.11 同时用户须做到：</p>
          <div class="p-content">
            <div class="item">
              <div class="point"></div>
              <div class="sub-content">
                用户名和昵称的注册与使用应符合网络道德，遵守中华人民共和国的相关法律法规。
              </div>
            </div>
            <div class="item">
              <div class="point"></div>
              <div class="sub-content">
                用户名和昵称中不能含有威胁、淫秽、漫骂、非法、侵害他人权益等有争议性的文字。
              </div>
            </div>
            <div class="item">
              <div class="point"></div>
              <div class="sub-content">
                注册成功后，用户必须保护好自己的帐号和密码，因用户本人泄露而造成的任何损失由用户本人负责。另外，每个用户都要对其帐户中的所有活动和事件负全责。用户可随时改变您的密码和图标，也可以结束旧的帐户重开一个新帐户。用户若发现任何非法使用用户帐号或安全漏洞的情况，应当立即通告爪玩。
              </div>
            </div>
            <div class="item">
              <div class="point"></div>
              <div class="sub-content">
                不得盗用他人帐号，由此行为造成的后果自负。
              </div>
            </div>
          </div>
        </div>
        <p class="sub-paragraph">
          3.12
          未经本站的授权或许可，任何用户不得借用本站的名义从事任何商业活动，也不得将本站作为从事商业活动的场所、平台或其他任何形式的媒介。禁止将本站用作从事各种非法活动的场所、平台或者其他任何形式的媒介。如用户违反上述规定，则爪玩有权直接采取一切必要的措施，包括但不限于删除用户发布的内容、取消用户在网站获得的星级、荣誉以及虚拟财富，暂停或查封用户帐号，乃至通过诉讼形式追究用户法律责任等。
        </p>
      </div>
    </div>
    <div class="paragraph">
      <div class="subTitle">4.爪玩权利和义务</div>
      <div class="content">
        <p class="sub-paragraph">
          4.1
          爪玩有义务在现有技术上维护整个平台的正常运行，并努力提升和改进技术，使用户网上交易活动得以顺利进行；对用户在注册使用爪玩上资源共享平台中所遇到的与交易或注册有关的问题及反映的情况，爪玩应及时作出回复；
        </p>
        <p class="sub-paragraph">
          4.2
          对于用户在爪玩网上平台上的不当行为或其它任何爪玩认为应当终止服务的情况，爪玩有权随时作出删除相关信息、终止服务等处理，而无须征得用户的同意；
        </p>
        <p class="sub-paragraph">
          4.3
          凡有用户恶意注册（为达到某种不正当的目的，进行非正常注册）爪玩帐号或产生作弊交易一经发现，爪玩均有权取消该用户在本网站的一切权利、权益，包括但不限于注销该用户相关信息、冻结其帐号、停止所有服务等处理，而无须征得用户的同意；
        </p>
        <p class="sub-paragraph">
          4.4
          因网上爪玩平台的特殊性，爪玩对所有用户的注册信息会进行审核，但仅限于通过微信账号登录及手机绑定的审核，如存在下列情况之一的，爪玩有权根据不同情况选择保留或删除相关信息或继续、停止对该用户提供服务，并追究相关法律责任。
        </p>
        <p class="sub-paragraph">
          4.4.1
          用户或其它第三方通知爪玩，认为某个具体用户或具体事项可能存在重大问题；
        </p>
        <p class="sub-paragraph">
          4.4.2
          用户或其它第三方向爪玩告知爪玩平台上有违法或不当行为的，爪玩以普通非专业知识水平标准对相关内容进行判别，可以明显认为这些内容或行为具有违法或不当性质的；
        </p>
        <p class="sub-paragraph">
          4.5
          一旦用户或其它会员任一方或双方共同提交爪玩要求争议调解处理的，爪玩有权通过用户提供的联系方式向纠纷双方了解情况，并将所了解的情况互相通知对方。经爪玩审核后，爪玩有权根据单方判断做出调处决定，用户了解并同意接受爪玩的判断和调处决定，调处双方对该决定应遵照执行。
        </p>
        <p class="sub-paragraph">
          4.6
          用户因在爪玩上交易物品与其它用户产生诉讼的，用户通过司法部门或行政部门依照法定程序要求爪玩提供相关数据，爪玩应依法配合并提供有关资料；
        </p>
        <p class="sub-paragraph">
          4.7
          爪玩有权对用户的注册数据及交易行为进行查阅，发现注册数据或爪玩行为中存在任何问题或怀疑，均有权向用户发出询问及要求改正的通知或者直接作出删除等处理；
        </p>
        <p class="sub-paragraph">
          4.8
          经国家生效法律文书或行政处罚决定确认用户存在违法行为，或者爪玩有足够事实依据可以认定用户存在违法或违反服务协议行为的，爪玩有权在爪玩平台及所在网站上以网络发布形式公布用户的违法行为；
        </p>
        <p class="sub-paragraph">
          4.9
          对于用户在爪玩平台发布的部分不合理信息，爪玩有权在不通知用户的前提下进行删除或采取其它限制性措施。
        </p>
        <p class="sub-paragraph">
          此类不合理信息包括但不限于：
        </p>
        <p class="sub-paragraph">
          ①以进行商业代购或商业买卖为目的信息；
        </p>
        <p class="sub-paragraph">
          ②以炒作不实信用为目的的信息；
        </p>
        <p class="sub-paragraph">
          ③爪玩有理由相信存在欺诈等恶意或虚假内容的信息；
        </p>
        <p class="sub-paragraph">
          ④爪玩有理由相信与物品交换无关或不是以交换为目的的信息；
        </p>
        <p class="sub-paragraph">
          ⑤爪玩有理由相信存在恶意扰乱正常爪玩秩序因素的信息；
        </p>
        <p class="sub-paragraph">
          ⑥爪玩有理由相信该信息违反公共利益或可能严重损害爪玩和其它用户合法利益的。
        </p>
        <p class="sub-paragraph">
          4.10
          关于许可使用权：用户以此授予爪玩独家的、全球通用的、永久的、免费的许可使用权利(并有权对该权利进行再授权)，使爪玩有权(全部或部份地)使用、复制、修订、改写、发布、翻译、分发、执行和展示用户公示于网站的各类信息或制作其派生作品，和/或以现在已知或日后开发的任何形式、媒体或技术，将上述信息纳入其它作品内；
        </p>
        <p class="sub-paragraph">
          4.11
          爪玩可在用户的设备上设定或取用爪玩cookies。爪玩允许在爪玩页上发布广告的主体到用户设备上设定或取用cookies。在用户登录时获取数据，爪玩使用cookies可为用户提供个性化服务。如果拒绝所cookies，用户将不能使用需要登录的爪玩产品及服务内容。
        </p>
      </div>
    </div>
    <div class="paragraph">
      <div class="subTitle">5.服务的中断和终止</div>
      <div class="content">
        <p class="sub-paragraph">
          5.1
          用户同意，爪玩可自行全权决定以任何理由(包括但不限于爪玩认为用户已违反本协议的字面意义和精神，或以不符合本协议的字面意义和精神的方式行事，)终止用户的“服务”密码、账户(或其任何部份)或用户对“服务”的使用，并删除（不再保存）用户在使用“服务”中提交的任何资料。同时爪玩可自行全权决定，在发出通知或不发出通知的情况下，随时停止提供“服务”或其任何部份。
          用户账号终止后，爪玩没有义务为用户保留原账号中或与之相关的任何信息，或转发任何未曾阅读或发送的信息给用户或第三方。此外，用户同意，爪玩不就终止用户接入“服务”而对用户或任何第三者承担任何责任；
        </p>
        <p class="sub-paragraph">
          5.2
          如用户向爪玩提出注销爪玩注册用户身份申请时，经爪玩审核同意，由爪玩注销该注册用户，用户即解除与爪玩的服务协议关系。在服务关系解除后，爪玩将不会承担任何意义上的责任。
        </p>
        <p class="sub-paragraph">
          但注销该用户账号后，爪玩仍保留下列权利：
        </p>
        <p class="sub-paragraph">
          ① 用户注销后，爪玩有权保留该用户的注册数据及以前的爪玩行为记录。
        </p>
        <p class="sub-paragraph">
          ②
          用户注销后，如用户在注销前在爪玩平台上存在违法行为或违反合同的行为，爪玩仍可行使本服务协议所规定的权利。
        </p>
        <p class="sub-paragraph">
          5.3 在下列情况下，爪玩可以通过注销用户的方式终止服务：
        </p>
        <p class="sub-paragraph">
          ①用户违反本服务协议相关规定时，爪玩有权终止向该用户提供服务；
        </p>
        <p class="sub-paragraph">
          ②如爪玩通过用户提供的信息与用户联系时，发现用户在注册时填写的联系方式无效，经爪玩以其它联系方式通知用户更改，而用户在一个月内仍未能提供新的有效联系方式的，爪玩有权终止向该用户提供服务；
        </p>
        <p class="sub-paragraph">
          ③一旦爪玩发现用户注册数据中主要内容是虚假的，爪玩有权随时终止向该用户提供服务；
        </p>
        <p class="sub-paragraph">
          ④本服务协议终止或更新时，用户明示不愿接受新的服务协议的；
        </p>
        <p class="sub-paragraph">
          ⑤其它爪玩认为需终止服务的情况。
        </p>
        <p class="sub-paragraph">
          5.4 服务中断、终止之前用户交易行为的处理
          因用户违反法律法规或者违反服务协议规定而致使爪玩中断、终止对用户服务的，对于服务中断、终止之前用户交易行为依下列原则处理：
        </p>
        <p class="sub-paragraph">
          ①
          服务中断、终止之前，用户已经上传至爪玩的物品尚未交易或尚未交易完成的，爪玩有权在中断、终止服务的同时删除此项物品的相关信息；
        </p>
        <p class="sub-paragraph">
          ②
          服务中断、终止之前，用户已经就其它用户交易的具体物品作出要约，但交易尚未结束，爪玩有权在中断或终止服务的同时删除该用户的相关要约；
        </p>
        <p class="sub-paragraph">
          ③
          服务中断、终止之前，用户已经与另一用户就具体交易达成一致，爪玩可以不删除该项交易，但爪玩有权在中断、终止服务的同时将用户被中断或终止服务的情况通知用户的交易对方；
        </p>
        <p class="sub-paragraph">
          ④
          一旦会员严重违规导致帐户被查封，则帐户中的爪玩优惠券和爪玩体验币将自动注销。
        </p>
        <p class="sub-paragraph">
          ④
          一旦会员严重违规导致帐户被查封，则帐户中的爪玩优惠券和爪玩体验币将自动注销。
        </p>
      </div>
    </div>
    <div class="paragraph">
      <div class="subTitle">6.责任范围</div>
      <div class="content">
        <p class="sub-paragraph">
          6.1
          爪玩向用户提供爪玩服务，但不对爪玩服务所涉及的技术及信息的是否有效、准确、正确、可靠以及其质量、稳定、完整和及时性作出任何承诺和保证。对爪玩服务不作任何明示或暗示的保证，包括但不限于爪玩服务的是否适用、是否存在错误或疏漏、是否具有持续、准确、可靠等性能、是否适用
          于某一特定用途等。
        </p>
        <p class="sub-paragraph">
          6.2
          用户知悉爪玩上的信息系用户自行发布，且可能存在风险和瑕疵。爪玩提醒用户应自行谨慎判定相关物品及/或信息的真实性、合法性和有效性，并自行承担因此产生的可能责任与损失。
        </p>
        <p class="sub-paragraph">
          爪玩仅作为物品信息查询平台及交易物品平台，就交易物品活动提供平台展示物品或服务信息、寻找交易对象、就物品和/或
          服务的交易提供服务，爪玩并不作为交易双方之任何一方的身份参与交易物品行为，且爪玩不负责对交易物品的货品或服务进行审核、无法控制交易物品所涉及的物品的
          质量、安全或合法性，商贸信息的真实性或准确性，以及交易各方履行其在贸易协议中各项义务的能力。本协议的签署并不意味着爪玩为爪玩平台上交易双方的行为合法性、有效性及货品的真实性、合法性、有效性提供任何明示或暗示的担保。
        </p>
        <p class="sub-paragraph">
          6.3
          用户明确理解和同意，爪玩不对因下述任一情况而导致的任何损害赔偿承担责任，包括但不限于商誉、使用、数据、利润等方面的损失或其它无形损失的损害赔偿
          (无论爪玩是否已被告知该等损害赔偿的可能性)；
        </p>
        <p class="sub-paragraph">
          6.3.1 第三方未经批准的接入或第三方更改用户的传输数据或数据；
        </p>
        <p class="sub-paragraph">
          6.3.2
          第三方对“服务”的声明或关于“服务”的行为；或非因爪玩的原因而引起的与“服务”有关的任何其它事宜，包括疏忽。
        </p>
        <p class="sub-paragraph">
          6.3.3
          用户明确理解并同意，如因其违反有关法律或者本协议之规定，使爪玩遭受任何损失，受到任何第三方的索赔，或任何行政管理部门的处罚，用户应对爪玩提供补偿，包括合理的律师费用。
        </p>
      </div>
    </div>
    <div class="paragraph">
      <div class="subTitle">7.交易条款</div>
      <div class="content">
        <p class="sub-paragraph">
          7.1 交易基本流程
        </p>
        <p class="sub-paragraph">
          卖家发布商品——买家在爪玩拍下宝贝——等待系统自动结算——出点最高买家支付----卖家发货（卖家可选择通过快递公司发货，或由买卖双方自行约定收货时间和地点）——买家收货
        </p>
        <p class="sub-paragraph">
          7.2交易程序
        </p>
        <p class="sub-paragraph">
          7.2.1
          添加产品描述信息。产品描述是由用户提供的在爪玩站上展示的文字描述、图片，可以是对用户拥有而用户希望出售的产品的描述；或对用户正寻找的产品的描述。用户可在爪玩站发布任一类产品描述。爪玩不对产品描述的准确性或内容负责。
        </p>
        <p class="sub-paragraph">
          7.2.2
          就交换进行协商交换各方通过在爪玩站上明确的物品描述，进行相互协商。所有各方接纳物品和方式将使所涉及的爪玩用户有义务完成交换。除非在特殊情况下，诸如用户在用户提出物品后实质性地更改对物品的描述或澄清任何文字输入错误，或用户未能证实交换所涉及的用户的身份等，物品的描述和对其的承诺均不得撤回。
        </p>
        <p class="sub-paragraph">
          7.2.3爪玩作为物品交换的中间平台，为鼓励爪玩用户在爪玩的发展，爪玩暂时免费为用户提供本协议项下的服务，但不排除今后为其提供的全部或部分用户或其他新增服务收取费用，具体政策将通过邮件、网站公告等形式提前公布收费政策及收费规则。具体依照爪玩平台规定为准。
        </p>
        <p class="sub-paragraph">
          7.2.4
          交换商品送达交换双方指定的接收地点（包括交换双方指定的暂存货地点），则代表本次易货交易完成。
        </p>
        <p class="sub-paragraph">
          7.2.5
          交易双方需要评估交易物品过程中产生的物品损耗，自行协商交易物品过程中产生的其他费用，包括但不限于：运输费、保管费等。
        </p>
        <p class="sub-paragraph">
          7.2.6
          交易方对收取的货物不满意（包括但不限于产品描述与网站不符合，如：商品名称、商品型号、商品图片、保质期、非本商品等），如果因此造成损失，由过错方承担相关费用及责任。
        </p>
        <p class="sub-paragraph">
          7.3关于仲裁处理
        </p>
        <p class="sub-paragraph">
          7.3.1买卖双方出现争议，可申请客服介入协助处理，可能涉及的买卖双方争议包括但不限于以下几种情形：
        </p>
        <p class="sub-paragraph">
          卖家实物与描述不符合或出现质量问题；
        </p>
        <p class="sub-paragraph">
          由于发货或物流等原因，导致买家未收到货、拒绝签收商品或签收后退回商品的；
        </p>
        <p class="sub-paragraph">
          双方约定不清，无法确定争议的责任归属的；
        </p>
        <p class="sub-paragraph">
          卖家收到退回的货物后，不确认退货；
        </p>
        <p class="sub-paragraph">
          买家恶意损坏商品。
        </p>
        <p class="sub-paragraph">
          7.3.2出现以下情形之一，爪玩客服不予处理，交由买卖方自行协调：
        </p>
        <p class="sub-paragraph">
          因商品存在危机人身财产权、人身健康权的不合理危险，导致买家损失的；
        </p>
        <p class="sub-paragraph">
          买家逾期未根据协议约定或爪玩规定的退货时间内操作退货的；
        </p>
        <p class="sub-paragraph">
          商品在收退货过程中因物流公司的原因导致毁损、丢失的；
        </p>
        <p class="sub-paragraph">
          买卖双方采用当面交付的方式进行交易。
        </p>
        <p class="sub-paragraph">
          7.3.3爪玩客服处理纠纷时，出现以下情况之一，有权终止协调和处理争议：
        </p>
        <p class="sub-paragraph">
          买卖双方明确要求自行处理争议；
        </p>
        <p class="sub-paragraph">
          买卖双方任何一方通知爪玩即将通过司法途径解决争议。
        </p>
        <p class="sub-paragraph">
          7.4违约赔偿
        </p>
        <p class="sub-paragraph">
          7.4.1
          逾期交付货物的，违约方应承担违约责任。爪玩有权调查并收集违约证据。
        </p>
        <p class="sub-paragraph">
          7.4.2
          用户违反有关法律、法规、公共道德或本协议项下的任何条款均构成违约。给其他第三人造成损失的，责任方应当承担由此造成的一切损失。爪玩有权视情况终止其用户资格，所收费用/保证金（如有）不予退还。
        </p>
        <p class="sub-paragraph">
          7.5用户交易规范：
        </p>
        <p class="sub-paragraph">
          买卖双方必须秉持诚信交易原则，卖家不可故意夸大实物从而误导买家；买家不可刻意损坏物品从而获取退款或退货机会；一旦发生此类事件，利益受损方可向爪玩客服寻求协助，客服介入调查解决；
        </p>
        <p class="sub-paragraph">
          闲置交易本身是个体对闲置或二手物品的出售，所以在购买前请双方就细节问题认真沟通，以免造成不必要的误会和麻烦，买家可以要求卖家多拍实物图；
        </p>
        <p class="sub-paragraph">
          一旦卖家已发货，买家不可在未收获的时候随意取消订单或申请退款。必须在收到货，确认货物有质量问题或与描述不符时方可申请退货退款；
        </p>
        <p class="sub-paragraph">
          卖家若涉嫌虚假物品交易，骗取钱财、滥发信息，经买家投诉，客服审核通过后，将冻结卖家账号；
        </p>
        <p class="sub-paragraph">
          买卖双方只可交易闲置物，不可进行商业代购或商业买卖。一旦收到投诉或经由客服发现，将冻结其账号。
        </p>
      </div>
    </div>
    <div class="paragraph">
      <div class="subTitle">8.隐私权政策</div>
      <div class="content">
        <p class="sub-paragraph">
          8.1 适用范围
        </p>
        <p class="sub-paragraph">
          8.1.1 用户注册爪玩账户时，用户根据爪玩要求提供的个人注册信息。
        </p>
        <p class="sub-paragraph">
          8.1.2
          在用户使用爪玩服务，参加爪玩活动，或访问爪玩页时，爪玩自动接收并记录的用户浏览器上的服务器数值，包括但不限于IP地址等数据及用户要求取用的网页记录。
        </p>
        <p class="sub-paragraph">
          8.1.3
          爪玩收集到的用户在爪玩进行交易的有关数据，包括但不限于搜索、爪玩、物品登录、信用度评价及违规记录。
        </p>
        <p class="sub-paragraph">
          8.1.4 爪玩通过合法途径取得的用户个人数据。
        </p>
        <p class="sub-paragraph">
          8.2 信息使用
        </p>
        <p class="sub-paragraph">
          8.2.1
          爪玩不会向任何人出售或出借用户的个人信息，除非事先得到用户得许可或基于法律规定。
        </p>
        <p class="sub-paragraph">
          8.2.2
          爪玩亦不允许任何第三方以任何手段收集、编辑、出售或者无偿传播用户的个人信息。任何用户如从事上述活动，一经发现，爪玩有权立即终止与该用户的服务协议，查封其账号。
        </p>
        <p class="sub-paragraph">
          8.2.3
          为服务用户的目的，爪玩可能通过使用用户的个人信息，向用户提供服务，包括但不限于向用户发出产品和服务信息。用户在享用爪玩用户服务的同时，同意接受爪玩平台用
        </p>
        <p class="sub-paragraph">
          8.3用户的个人信息将在下述情况下部分或全部被披露：
        </p>
        <p class="sub-paragraph">
          经用户同意，向第三方披露；
        </p>
        <p class="sub-paragraph">
          如用户是合格的知识产权人并已被提起投诉，应被投诉人要求，向被投诉人披露，以便双方处理可能的权利纠纷；
        </p>
        <p class="sub-paragraph">
          根据法律的有关规定，或者行政或司法机构的要求，向第三方或者行政、司法机构披露；
        </p>
        <p class="sub-paragraph">
          根据法律的有关规定，或者行政或司法机构的要求，向第三方或者行政、司法机构披露；
        </p>
        <p class="sub-paragraph">
          为提供你所要求的产品和服务，而必须和第三方分享用户的个人信息；
        </p>
        <p class="sub-paragraph">
          其他本网站根据法律或者网站政策认为合适的披露。
        </p>
        <p class="sub-paragraph">
          8.4爪玩在爪玩平台公布并不时修订隐私权政策，隐私权政策构成本协议的有效组成部分。
        </p>
      </div>
    </div>
    <div class="paragraph">
      <div class="subTitle">9.保密条款</div>
      <div class="content">
        <p class="sub-paragraph">
          用户未经其他各方书面同意，不得泄露在物品交易洽商或履行过程中所知悉的其他各方的商业秘密、个人隐私等，否则应当承担相应法律责任。
        </p>
      </div>
    </div>
    <div class="paragraph">
      <div class="subTitle">10. 知识产权保护</div>
      <div class="content">
        <p class="sub-paragraph">
          10.1任何用户接受本注册协议，即表明该用户主动将其在任何时间段在本站发表的任何形式的信息的著作财产权，包括并不限于：复制权、发行权、出租权、展览权、表演权、放映权、广播权、信息网络传播权、摄制权、改编权、翻译权、汇编权以及应当由著作权人享有的其他可转让权利无偿独家转让给爪玩运营商所有，同时表明该用户许可爪玩有权利就任何主体侵权而单独提起诉讼，并获得全部赔偿。
          本协议已经构成《著作权法》第二十五条所规定的书面协议，其效力及于用户在爪玩发布的任何受著作权法保护的作品内容，无论该内容形成于本协议签订前还是本协议签订后。用户同意并明确了解上述条款，不将已发表于本站的信息，以任何形式发布或授权其它网站（及媒体）使用。
        </p>
        <p class="sub-paragraph">
          10.2爪玩站所使用的任何相关软件、程序、内容，包括但不限于作品、图片、文字、音频、视频、档案、资料、网站构架、网站版面的安排、网页设计、经由本网站或广告商向成员或客户呈现的广告或资讯，均由爪玩平台或其它权利人依法享有相应的知识产权，包括但不限于著作权、商标权或其它专属权利等，受到相关法律的保护。用户保证仅限于履行本合同使用。未经爪玩或其他权利人明示授权，不得擅自使用，包括但不限于以非法的方式复制、传播、展示、镜像、上载、下载、修改、出租、出借、出售、散布爪玩平台的上述任何资料和资源，或根据上述资料和资源制作成任何种类产品。否则，爪玩将依法追究法律责任。
        </p>
      </div>
    </div>
    <div class="paragraph">
      <div class="subTitle">11. 遵守法律</div>
      <div class="content">
        <p class="sub-paragraph">
          用户应遵守与其使用“交换服务”，以及与其竞买、购买和销售任何物品以及提供商贸信息有关的所有相关的中华人民共和国法律、法规、条例和规章。爪玩对于用户由于使用爪玩而造成的任何金钱、商誉、名誉的损失，或任何特殊的、间接的、或结果性的损失都不负任何责任。
        </p>
      </div>
    </div>
    <div class="paragraph">
      <div class="subTitle">12. 其他规定</div>
      <div class="content">
        <p class="sub-paragraph">
          12.1
          本网站协议各方面应受中华人民共和国大陆地区法律的管辖。倘若本网站协议任何规定被裁定为无效或不可强制执行，该项规定应被撤销，而其余规定应予执行。条款标题仅为方便参阅而设，并不以任何方式界定、限制、解释或描述该条款的范围或限度。本网站未就用户或其他人士的某项违约行为采取行动，并不表明本网站撤回就任何继后或类似的违约事件采取行动的权利。
        </p>
        <p class="sub-paragraph">
          12.2
          爪玩如发现用户有本协议约定的任何方面违约、违规,甚至违法行为，爪玩有权进行相应的处罚，包括:通报,警告,信用降级、封锁用户账号，取消用户资格或用户资格涉嫌犯罪的将移交司法机关。
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  mounted() {
    document.title = '爪玩用户服务协议'
  },
}
</script>

<style lang="less" scoped>
.page {
  padding: 12px;
}
p {
  text-align: justify;
}
.title {
  font-size: 22px;
  font-weight: 600;
  text-align: center;
  color: #000;
}
.paragraph {
  margin: 20px 0;
  .subTitle {
    font-size: 18px;
    font-weight: 400;
    color: #000;
  }
  .content {
    margin: 8px 0;
    font-size: 14px;
    color: #333;
    .sub-paragraph {
      margin: 8px 0;
    }
  }
}
.p-content {
  margin: 10px 0;
}
.item {
  display: flex;
  align-items: flex-start;
  .point {
    width: 5px;
    height: 5px;
    border-radius: 3px;
    background: #000;
    margin: 8px 10px 0 20px;
  }
  .sub-content {
    flex: 1;
  }
}
</style>
